var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3558 3.6442C16.4969 -1.21473 8.50314 -1.21473 3.6442 3.6442C-1.21473 8.50314 -1.21473 16.4969 3.6442 21.3558C8.50314 26.2147 16.4969 26.2147 21.3558 21.3558C26.2147 16.4969 26.2147 8.65987 21.3558 3.6442ZM14.4592 16.1834L12.4216 14.1458L10.384 16.1834C9.91379 16.6536 9.28683 16.6536 8.81662 16.1834C8.3464 15.7132 8.3464 15.0862 8.81662 14.616L10.8542 12.5784L8.81662 10.5408C8.3464 10.0705 8.3464 9.44357 8.81662 8.97335C9.28683 8.50314 9.91379 8.50314 10.384 8.97335L12.4216 11.011L14.4592 8.97335C14.9295 8.50314 15.5564 8.50314 16.0266 8.97335C16.4969 9.44357 16.4969 10.0705 16.0266 10.5408L13.989 12.5784L16.0266 14.616C16.4969 15.0862 16.4969 15.7132 16.0266 16.1834C15.7132 16.6536 14.9295 16.6536 14.4592 16.1834Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.84c7ad7d21b52e38d675023ab5366210.svg";
export { ForwardRef as ReactComponent };